import HtmlBuilder from '@/class/HtmlBuilder';
import Autocomplete from '@/class/autocomplete/Autocomplete';
class SearchField {
    constructor(label, config) {
        const input = document.createElement('input');
        input.setAttribute('type', 'text');
        input.classList.add('calcZV__input');
        this._input = input;
        this._label = label;
        this.block = HtmlBuilder.createBlock(label, input);
        this._config = config;
        this._plugin = this.autocomplete();
    }
    get label() {
        return this._label;
    }
    set label(label) {
        this._label = HtmlBuilder.updateLabel(this.block, label);
    }
    get value() {
        return this._plugin.value;
    }
    set value(value) {
        this._input.value = value;
    }
    remove() {
        this.block.remove();
    }
    changeOptions(options, selectFirst = true) {
        this._plugin.updateSuggestions(options, selectFirst);
    }
    onChange(cb) {
        this._plugin.onSelect(cb);
    }
    autocomplete() {
        return new Autocomplete(this._input, this._config, true);
    }
}
export default SearchField;
